import apiClient from "../config/apiClient"; // Assuming apiClient is set up to handle base API configurations
import { API_ENDPOINTS } from "../config/endpoints"; // Replace this with the actual endpoint for your use case
import { handleApiError } from "../config/errorHandler"; // Error handling utility

/**
 * Request support delivery by area
 * @param {string} areaName - The name of the area to request delivery support for
 * @param {string} serviceType - The type of service (delivery in this case)
 * @returns {Promise<Object>} - Response data from the API
 */
export const getBrandsByArea = async (areaName, serviceType) => {
  try {
    const response = await apiClient.post(
      API_ENDPOINTS.SUPPORT_DELIVERY_BY_AREA, // Replace with the correct endpoint
      {
        area_name: areaName,
        service_type: serviceType || "delivery",
        platform: "POS",
      }
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
